import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = 'oldPages/insert-management/index.html';

const links: Record<string, string> = {
  create: '/infoTrac/insert-management/create',
  edit: '/infoTrac/insert-management/step1',
  approve: '/infoTrac/insert-management/approve',
  detail: '/infoTrac/insert-management/detail',
  remove: '/infoTrac/insert-management/remove',
  copied: '/infoTrac/insert-management?act=copied',
  link: '/infoTrac/insert-management/link',
  update: '/infoTrac/insert-management/modify',
};

function InsertManagement() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const create = iframeDocument.getElementById('create-new');

      if (create) create.addEventListener('click', () => navigate(links.create));

      const edit = iframeDocument.getElementsByClassName('edit-step-1');
      const approve = iframeDocument.getElementsByClassName('approve');
      const detail = iframeDocument.getElementsByClassName('detail');
      const remove = iframeDocument.getElementsByClassName('remove');
      const link = iframeDocument.getElementsByClassName('link');
      const insertDocs = iframeDocument.getElementsByClassName('insert-doc');
      const update = iframeDocument.getElementsByClassName('update');
      const copied = iframeDocument.getElementById('copy');

      if (copied) {
        copied.addEventListener('click', () => {
          window.location.href = links.copied;
        });
      }

      if (edit.length) {
        for (let i = 0; i < edit.length; i++) {
          edit[i].addEventListener('click', () => {
            const row = (edit[i] as HTMLElement).closest('tr');
            const description = row?.children[4]?.textContent?.trim() || '';
            const params = description ? `?description=${encodeURIComponent(description)}` : '';
            navigate(`${links.edit}${params}`);
          });
        }
      }

      if (approve.length) {
        for (let i = 0; i < approve.length; i++) {
          approve[i].addEventListener('click', () => navigate(links.approve));
        }
      }

      if (remove.length) {
        for (let i = 0; i < remove.length; i++) {
          remove[i].addEventListener('click', () => navigate(links.remove));
        }
      }

      if (link.length) {
        for (let i = 0; i < link.length; i++) {
          link[i].addEventListener('click', () => navigate(links.link));
        }
      }

      if (insertDocs.length) {
        for (let i = 0; i < insertDocs.length; i++) {
          insertDocs[i].addEventListener('click', event => {
            event.preventDefault();
            const href = (insertDocs[i] as HTMLAnchorElement).getAttribute('href');
            if (href && href !== '#') {
              window.open(href, '_blank', 'noopener,noreferrer');
            }
          });
        }
      }

      if (update.length) {
        for (let i = 0; i < update.length; i++) {
          update[i].addEventListener('click', () => navigate(links.update));
        }
      }

      if (detail.length) {
        for (let i = 0; i < detail.length; i++) {
          detail[i].addEventListener('click', () => window.open(links.detail, '_blank'));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="insert-management"
      src={path}
      className="z-[100] relative"
      width="100%"
      height="700px"
    />
  );
}

export default InsertManagement;
